import { breakpoints } from '@bnnvara/breakpoints';
import { BaseButton } from '@bnnvara/buttons';
import BaseNotification from '@bnnvara/notifications';
import styled from 'styled-components';

export const Content = styled.div`
  width: 75%;
  max-width: 343px;
  height: auto;
  margin: auto;
  background-color: ${({ theme }) => theme.base.white};
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${breakpoints.md} {
    max-width: 500px;
    width: 100%;
  }
  ${breakpoints.md} {
    padding: 32px;
  }
`;

export const CloseButton = styled(BaseButton)`
  margin: 20px 0;
`;

export const StyledLikeButtonContainer = styled.div`
  margin-right: 16px;
`;

export const StyledBaseNotification = styled(BaseNotification)`
  margin-top: -5px;

  span {
    font-weight: bold;
    color: ${({ theme }) => theme.base.red};
  }

  p {
    display: block;
    background: ${({ theme }) => theme.base.white};
    margin-left: -10px;
    padding-left: 10px;
    position: relative;
    z-index: 1;
  }
`;
